import React from 'react'
import { inject, observer } from 'mobx-react'

import FormRenderer from '../../../../../generic/FormRenderer'
import Input from '../../../../../generic/Input'
import Checkbox from '../../../../../generic/Checkbox'

const EditReinfForm = inject('editReinfStore')(observer(props => {
  const { editReinfStore } = props
  const { cliente, alias, dir_xml, email, ativo } = editReinfStore.state.data
  const formFields = [{
    component: Input,
    label: 'Cliente',
    type: 'text',
    name: 'cliente',
    id: 'edit-reinf-cliente',
    value: cliente,
    placeholder: 'Cliente'
  },{
    component: Input,
    label: 'Alias',
    type: 'text',
    name: 'alias',
    id: 'edit-reinf-alias',
    value: alias,
    placeholder: 'Alias'
  },{
    component: Input,
    label: 'Diretório do XML',
    type: 'text',
    name: 'dir_xml',
    id: 'edit-reinf-dir_xml',
    value: dir_xml,
    placeholder: 'Diretório do XML'
  },{
    component: Input,
    label: 'E-mail',
    type: 'email',
    name: 'email',
    id: 'edit-reinf-email',
    value: email,
    placeholder: 'E-mail'
  },{
    component: Checkbox,
    text: 'Ativo',
    isChecked: ativo,
    onChange: () => editReinfStore.toggleActive()
  }]
  return (
    <FormRenderer fields={formFields} store={editReinfStore} />
  )
}))

export default EditReinfForm



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/products/reinf/EditReinfForm.js